import { render, staticRenderFns } from "./ConfirmedForm.vue?vue&type=template&id=27d84b7c&scoped=true&"
import script from "./ConfirmedForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d84b7c",
  null
  
)

export default component.exports